import React from 'react';

import { isGoGameEnv } from 'App/constants';

import { makeStyles } from '@gogame/components';
import { Outlet, ScreenModalProviderV2 } from '@gogame/screens';

import { ActiveUser } from '../Auth';
import MaintenanceToolbar from './components/Maintenance/Toolbar';
import { SidebarToolbar, PartnersSidebarToolbar } from './components/Sidebar';
import { SystemMessages } from './components/SystemMessages';
import {
  useSocketMessage,
  useSocketQueryRefetch,
} from './components/WebSocket';
import { useNextDayReload } from './useNextDayReload';

const useStyles = makeStyles(
  () => {
    return {
      root: {
        paddingLeft: '64px',
      },
      container: {
        height: '100%',
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      },
      content: {
        display: 'flex',
        minHeight: 'calc(100vh - 64px)',
        flexDirection: 'column',
      },
      toolBar: {
        display: 'flex',
        width: '100%',
        height: '64px',
      },
    };
  },
  { name: 'GgApplication' }
);

const Application = () => {
  useSocketMessage();
  useSocketQueryRefetch();
  useNextDayReload();

  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.root}>
        <ScreenModalProviderV2>
          <ActiveUser>
            {isGoGameEnv ? <SidebarToolbar /> : <PartnersSidebarToolbar />}
          </ActiveUser>
        </ScreenModalProviderV2>
        <div className={classes.container}>
          <MaintenanceToolbar />
          <Outlet />

          {isGoGameEnv && <SystemMessages />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Application;
